import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";

export const Modal = ({ open, onClose, title, description, children, testid }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid={testid} className="max-h-[90vh] overflow-y-auto border-[#1E293B] bg-[#0A0E1A] text-white sm:max-w-lg sm:rounded-2xl">
      <DialogTitle className="font-display text-3xl font-extrabold uppercase tracking-tight text-white">{title}</DialogTitle>
      {description && <DialogDescription className="text-sm text-slate-400">{description}</DialogDescription>}
      {children}
    </DialogContent>
  </Dialog>
);

const inputCls = "w-full rounded-xl border border-[#1E293B] bg-[#0F172A] px-3.5 py-2.5 text-sm text-white outline-none transition-colors placeholder:text-slate-500 focus:border-[#39FF14]";

export const Field = ({ label, className = "", children }) => (
  <label className={`block ${className}`}>
    <span className="mb-1.5 block font-mono-gd text-[11px] uppercase tracking-[0.2em] text-slate-400">{label}</span>
    {children}
  </label>
);

export const TextInput = ({ className = "", ...rest }) => <input className={`${inputCls} ${className}`} {...rest} />;

export const TextArea = ({ className = "", ...rest }) => <textarea rows={3} className={`${inputCls} resize-none ${className}`} {...rest} />;

export const Chips = ({ options, value, onChange, multi = false, testid }) => {
  const on = (o) => (multi ? value.includes(o) : value === o);
  const toggle = (o) => onChange(multi ? (on(o) ? value.filter((v) => v !== o) : [...value, o]) : o);
  return (
    <div className="flex flex-wrap gap-1.5">
      {options.map((o) => {
        const [val, label] = Array.isArray(o) ? o : [o, o];
        return (
          <button type="button" key={val} data-testid={`${testid}-${val}`} onClick={() => toggle(val)}
            className={`rounded-full px-3.5 py-2 font-mono-gd text-xs uppercase transition-colors ${on(val) ? "bg-[#39FF14] text-[#0A0E1A]" : "bg-[#162032] text-slate-300 hover:text-white"}`}>
            {label}
          </button>
        );
      })}
    </div>
  );
};

export const numOrNull = (v) => (v === "" || v === null || v === undefined || Number.isNaN(Number(v)) ? null : Number(v));
